import React, { useState, useEffect } from 'react';
import { ref, get, remove } from 'firebase/database';
import { database } from '../../firebase/config';
import { formattaData } from '../../utils/dateUtils';
import { deleteImmagine } from '../../utils/cloudinaryUtils';

function VisualizzaFotoCantiere({ dipendente, onClose }) {
  const [foto, setFoto] = useState([]);
  const [cantieri, setCantieri] = useState([]);
  const [clienti, setClienti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fotoSelezionata, setFotoSelezionata] = useState(null);
  const [filtroData, setFiltroData] = useState('');
  const [filtroCantiere, setFiltroCantiere] = useState('');
  const [messaggioCancellazione, setMessaggioCancellazione] = useState('');

  useEffect(() => {
    caricaDati();
  }, [dipendente]);

  async function caricaDati() {
    setLoading(true);
    const [fotoSnap, cantSnap, cliSnap] = await Promise.all([
      get(ref(database, 'fotoCantiere')),
      get(ref(database, 'cantieri')),
      get(ref(database, 'clienti')),
    ]);
    if (cantSnap.exists()) {
      setCantieri(Object.keys(cantSnap.val()).map(k => ({ id: k, ...cantSnap.val()[k] })));
    }
    if (cliSnap.exists()) {
      setClienti(Object.keys(cliSnap.val()).map(k => ({ id: k, ...cliSnap.val()[k] })));
    }
    if (fotoSnap.exists()) {
      const tutte = Object.keys(fotoSnap.val()).map(k => ({ id: k, ...fotoSnap.val()[k] }));
      const delDipendente = tutte
        .filter(f => f.dipendenteId === dipendente.id)
        .sort((a, b) => b.createdAt - a.createdAt);
      setFoto(delDipendente);
    } else {
      setFoto([]);
    }
    setLoading(false);
  }

  function getCantiere(id) {
    return cantieri.find(c => c.id === id);
  }

  function getCliente(cantiereId) {
    const cantiere = getCantiere(cantiereId);
    if (!cantiere) return null;
    return clienti.find(c => c.id === cantiere.clienteId);
  }

  const cantieriConFoto = cantieri.filter(c => foto.some(f => f.cantiereId === c.id));

  const fotoFiltrate = foto
    .filter(f => !filtroData || f.data === filtroData)
    .filter(f => !filtroCantiere || f.cantiereId === filtroCantiere);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content modal-large"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
         <h2>📷 Foto Cantiere — {dipendente.nome} {dipendente.cognome} </h2>
          
              <button 
                onClick={onClose}
                style={{
                  background: '#e74c3c',
                  border: 'none',
                  color: 'white',
                  padding: '8px 15px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '18px',
                  marginRight: '0px',
                  height: 'fit-content'
                }}
              >
                ✕
              </button>
        </div>

        {/* Filtri */}
        <div style={{ padding: '16px 24px', borderBottom: '1px solid #dee2e6', display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center' }}>
          <div>
            <label style={{ marginRight: 8, fontWeight: 600 }}>Data:</label>
            <input
              type="date"
              value={filtroData}
              onChange={e => setFiltroData(e.target.value)}
            />
          </div>
          <div>
            <label style={{ marginRight: 8, fontWeight: 600 }}>Cantiere:</label>
            <select
              value={filtroCantiere}
              onChange={e => setFiltroCantiere(e.target.value)}
            >
              <option value="">— Tutti —</option>
              {cantieriConFoto.map(c => {
                const cliente = getCliente(c.id);
                return (
                  <option key={c.id} value={c.id}>
                    {c.luogo} {cliente ? `(${cliente.ragioneSociale})` : ''}
                  </option>
                );
              })}
            </select>
          </div>
          {(filtroData || filtroCantiere) && (
            <button
              onClick={() => { setFiltroData(''); setFiltroCantiere(''); }}
              style={{ cursor: 'pointer', color: '#e74c3c', border: 'none', background: 'none', fontWeight: 700 }}
            >
              ✕ Rimuovi filtri
            </button>
          )}
        </div>

        {/* Messaggio cancellazione */}
        {messaggioCancellazione && (
          <div style={{
            margin: '12px 24px 0',
            padding: '8px 12px',
            background: '#eaffea',
            color: 'green',
            fontWeight: 600,
            borderRadius: 6
          }}>
            {messaggioCancellazione}
          </div>
        )}

        <div style={{ padding: 24, overflowY: 'auto', maxHeight: '65vh' }}>
          {loading ? (
            <p>Caricamento...</p>
          ) : fotoFiltrate.length === 0 ? (
            <p style={{ color: '#7f8c8d' }}>Nessuna foto trovata</p>
          ) : (
            <>
              <p style={{ color: '#7f8c8d', marginBottom: 16 }}>
                {fotoFiltrate.length} {fotoFiltrate.length === 1 ? 'foto' : 'foto'}
              </p>
              <div className="foto-grid">
                {fotoFiltrate.map(f => {
                  const cantiere = getCantiere(f.cantiereId);
                  const cliente = getCliente(f.cantiereId);
                  return (
                    <div
                      key={f.id}
                      className="foto-item"
                      style={{ cursor: 'pointer' }}
                      onClick={() => setFotoSelezionata(f)}
                    >
                      <img src={f.imageUrl} alt="Foto cantiere" className="foto-thumb" />
                      <small>{formattaData(f.data)}</small>
                      <small>{cantiere?.luogo || 'N/D'}</small>
                      <small style={{ color: '#2c3e50', fontWeight: 600 }}>
                        {cliente?.ragioneSociale || ''}
                      </small>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Lightbox */}
      {fotoSelezionata && (
        <div
          className="modal-overlay"
          style={{ zIndex: 1100 }}
          onClick={() => setFotoSelezionata(null)}
        >
          <div
            className="modal-content"
            style={{ maxWidth: 560, textAlign: 'center' }}
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3>
                {formattaData(fotoSelezionata.data)} —{' '}
                {getCantiere(fotoSelezionata.cantiereId)?.luogo || 'N/D'}
              </h3>
                            <button 
                onClick={onClose}
                style={{
                  background: '#95a5a6',
                  border: 'none',
                  color: 'white',
                  padding: '8px 15px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '18px',
                  marginRight: '0px'
                }}
              >
                ✕
              </button>
            </div>
            <img
              src={fotoSelezionata.imageUrl}
              alt="Foto cantiere"
              style={{ width: '100%', borderRadius: 8, marginTop: 12 }}
            />
            <a
              href={fotoSelezionata.imageUrl}
              download
              target="_blank"
              rel="noreferrer"
              style={{ display: 'inline-block', marginTop: 12, color: '#667eea', fontWeight: 600 }}
            >
              ⬇️ Scarica foto
            </a>
            <button
              onClick={async () => {
                if (!window.confirm('Sei sicuro di voler cancellare definitivamente questa foto?')) return;
                try {
                  await deleteImmagine(fotoSelezionata.publicId);
                } catch (e) {
                  console.warn('Cloudinary non raggiunto:', e.message);
                }
                try {
                  await remove(ref(database, `fotoCantiere/${fotoSelezionata.id}`));
                  setFotoSelezionata(null);
                  await caricaDati();
                  setMessaggioCancellazione('✅ Foto cancellata con successo!');
                  setTimeout(() => setMessaggioCancellazione(''), 3000);
                } catch (e) {
                  alert('Errore durante la cancellazione: ' + e.message);
                }
              }}
              style={{
                display: 'inline-block',
                marginTop: 12,
                marginLeft: 12,
                background: '#e74c3c',
                color: '#fff',
                border: 'none',
                padding: '8px 14px',
                borderRadius: 6,
                cursor: 'pointer',
                fontWeight: 600
              }}
            >
              🗑️ Cancella foto
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default VisualizzaFotoCantiere;
